export default "__VITE_ASSET__CN3LUtkg__"